export const FONTS = {
  ROBOTO: 'Roboto',
  SUNDRY: 'Sundry',
} as const

export type FontFamily = typeof FONTS[keyof typeof FONTS]
